import React from 'react';
import { Switch, Redirect,Route } from 'react-router-dom';

import { RouteWithLayout, PrivateRouteWithLayout } from './components';
import { Minimal as MinimalLayout, Main as MainLayout } from './layouts';

import {
  SignIn as SignInView,
  SignOut as SignOutView,
  NotFound as NotFoundView,
  ScheduleAttendant as ScheduleAttendantView,
  Settings as SettingsView,
  Admin as AdminView
} from './views';

const Routes = (props) => {
  return (
    <Switch>
      <PrivateRouteWithLayout
        component={ScheduleAttendantView}
        exact
        layout={MainLayout}
        path="/scheduleattendant"
      />
      <PrivateRouteWithLayout
        component={AdminView}
        exact
        layout={MainLayout}
        path="/admin"
      />
      <PrivateRouteWithLayout
        component={SettingsView}
        exact
        layout={MainLayout}
        path="/settings"
      />
      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path="/sign-in"
      />
      <RouteWithLayout
        component={SignOutView}
        exact
        layout={MinimalLayout}
        path="/sign-out"
      />
      <RouteWithLayout
        component={NotFoundView}
        exact
        layout={MinimalLayout}
        path="/not-found"
      />
       <Route path="/">
        <Redirect
            to={{
              pathname: "/scheduleattendant"
            }}
          />
      </Route>
      <Route path="*">
        <Redirect
            to={{
              pathname: "/not-found"
            }}
          />
      </Route>
      
    </Switch>
  );
};

export default Routes;

